import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Title, Button } from '@qonsoll/react-design'
import { MAX_LENGTH_FIELD, MAX_LENGTH_DESCRIPTION, KEYS } from '__constants__'
import { Form, Input } from 'antd'

const DatabaseSimpleForm = (props) => {
  const { initialValues, onSubmit, onCancel, showTitle, form, group } = props

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const [baseForm] = Form.useForm()

  // [COMPUTED_PROPERTIES]
  const usedForm = form || baseForm

  // [HANDLERS]
  const handleCancel = () => {
    usedForm.resetFields()
    onCancel?.()
  }
  const handleKeyPress = (e) => {
    if (e.key === KEYS.ENTER) {
      e.preventDefault()
      e.stopPropagation()
      usedForm?.submit()
    }
  }

  return group ? (
    <>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Database')}
        </Title>
      )}
      <Form.Item
        label={t('Data models')}
        name={[...group, 'dataModels']}
        rules={[
          {
            required: false,
            message: t('Please enter your database data models!')
          },
          {
            max: MAX_LENGTH_FIELD,
            message: t('database data models is too long!')
          }
        ]}>
        <Input
          placeholder={t('Please enter your database data models')}
          onPressEnter={onSubmit}
        />
      </Form.Item>
      <Form.Item
        label={t('Enums')}
        name={[...group, 'enums']}
        rules={[
          {
            required: false,
            message: t('Please enter your database enums!')
          },
          { max: MAX_LENGTH_FIELD, message: t('database enums is too long!') }
        ]}>
        <Input placeholder={t('Please enter your database enums')} />
      </Form.Item>
    </>
  ) : (
    <Form
      form={usedForm}
      initialValues={initialValues}
      onFinish={onSubmit}
      layout="vertical"
      onKeyPress={handleKeyPress}
      autoComplete="off">
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Database')}
        </Title>
      )}
      <Form.Item
        label={t('Data models')}
        name="dataModels"
        rules={[
          {
            required: false,
            message: t('Please enter your database data models!')
          },
          {
            max: MAX_LENGTH_FIELD,
            message: t('database data models is too long!')
          }
        ]}>
        <Input placeholder={t('Please enter your database data models')} />
      </Form.Item>
      <Form.Item
        label={t('Enums')}
        name="enums"
        rules={[
          {
            required: false,
            message: t('Please enter your database enums!')
          },
          { max: MAX_LENGTH_FIELD, message: t('database enums is too long!') }
        ]}>
        <Input placeholder={t('Please enter your database enums')} />
      </Form.Item>
      {!form && (
        <>
          <Button mr={2} htmlType="button" onClick={handleCancel}>
            {t('Cancel')}
          </Button>
          <Button type="primary" onClick={() => usedForm.submit()}>
            {t('Save')}
          </Button>
        </>
      )}
    </Form>
  )
}

DatabaseSimpleForm.propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  showTitle: PropTypes.bool,
  form: PropTypes.any,
  group: PropTypes.array
}

export default DatabaseSimpleForm
